export default __webpack_public_path__ + "static/media/tesla-master-of-lightning.440202e1.png";